<!-- PUBLIC NAV w/ LOGIN -->
<div class="border-bottom navy-bg public-nav">
  <div class="container">
    <nav
      class="row navbar navbar-static-top mb-0"
      role="navigation">
      <div class="col-lg-5">
        <a routerLink="/" class="logo-link">
          <img
            title="InfoDocs Logo Colour Transparent"
            src="assets/img/infodocs-logo.png"
            class="logo"
            />
        </a>
      </div>
      <div class="col-lg-7">
        <form
          [formGroup]="loginForm"
          (ngSubmit)="submit()"
          class="login-form form-inline"
          >
          <!-- ERRORS -->
          @if (errors()) {
            <div class="alert alert-danger" role="alert">
              @for (error of errors(); track error) {
                <div>{{ error }}</div>
              }
            </div>
          }

          <!-- EMAIL ADDRESS -->
          <div class="form-group">
            <input
              type="email"
              class="form-control"
              [class.is-valid]="loginForm.get('email')?.valid"
							[class.is-invalid]="
							loginForm.get('email')?.touched && !loginForm.get('email')?.valid
						"
              autocomplete="username"
              formControlName="email"
              placeholder="Email Address"
              dusk="header-email-input"
              />
            <label>
              <input type="checkbox" formControlName="remember" tabindex="3" />
              <span class="label-text"> Keep me logged in</span>
            </label>
          </div>

          <!-- PASSWORD -->
          <div class="form-group">
            <input
              type="password"
              class="form-control"
              [class.is-valid]="loginForm.get('password')?.valid"
							[class.is-invalid]="
							loginForm.get('password')?.touched &&
							!loginForm.get('password')?.valid
						"
              autocomplete="current-password"
              formControlName="password"
              placeholder="Password"
              dusk="header-password-input"
              />
            <a class="forgot-password" routerLink="/account/reset-password">
              Forgot your password?
            </a>
          </div>

          <button type="submit" class="btn btn-login" dusk="header-login-button">
            Log In
          </button>
        </form>
      </div>
    </nav>
  </div>
</div>
